export default __webpack_public_path__ + "media/samples/BODY_WELCOME-1d46abf7.jpg";